<template>
	<section class="min-h-32 rounded-md p-3" :class="evolution > 0 ? 'bg-gradient-green' : 'bg-gradient-red'">
		<div v-if="!loading" class="flex flex-col gap-2 w-full lg:w-auto justify-around text-white">
			<div class="text-xl uppercase">
				{{ title }}
			</div>
			<div class="text-4xl font-bold text-white">
				<span> {{ evolution }} </span>
			</div>
			<div class="text-md uppercase">
				{{ bottomMessage }}
			</div>
		</div>
		<div v-else class="flex flex-col gap-2 w-full lg:w-auto justify-around text-white">
			<div class="text-xl uppercase">
				{{ title }}
			</div>
			<div class="text-4xl text-center">
				<i class="fa-duotone fa-solid fa-spinner-third fa-spin"></i>
			</div>
		</div>
	</section>
</template>

<script setup>
	const props = defineProps({
		title: {
			type: String,
			default: '',
		},
		evolution: {
			type: Number,
			default: 0,
		},
		bottomMessage: {
			type: String,
			default: '',
		},
		loading: {
			type: Boolean,
			default: false,
		},
	});
</script>
